'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState, useCallback } from 'react';
import { useRefinementList } from 'react-instantsearch';
import Checkbox from 'components/consumer/Checkbox';
import useAdvancedSearchContext from '../../../hooks/useAdvancedSearchContext';
const DEFAULT_LIMIT = 10;
const SHOW_MORE_LIMIT = 500;
const ProductTypeRefinementList = () => {
  const $ = _c(31);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      attribute: "type",
      limit: SHOW_MORE_LIMIT
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    items,
    refine
  } = useRefinementList(t0);
  const {
    updateUrlParamImmediate,
    updateTypeFilter
  } = useAdvancedSearchContext();
  const [showMore, setShowMore] = useState(false);
  let t1;
  if ($[1] !== items) {
    t1 = items?.filter(_temp) || [];
    $[1] = items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const itemsWithHits = t1;
  let t2;
  if ($[3] !== itemsWithHits) {
    t2 = itemsWithHits?.some(_temp2) || false;
    $[3] = itemsWithHits;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const isAnyRefined = t2;
  let t3;
  if ($[5] !== isAnyRefined || $[6] !== itemsWithHits) {
    let t4;
    if ($[8] !== isAnyRefined) {
      t4 = item_1 => !isAnyRefined || item_1.isRefined;
      $[8] = isAnyRefined;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = itemsWithHits.filter(t4);
    $[5] = isAnyRefined;
    $[6] = itemsWithHits;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const validItems = t3;
  let t4;
  if ($[10] !== showMore || $[11] !== validItems) {
    t4 = showMore ? validItems : validItems.slice(0, DEFAULT_LIMIT);
    $[10] = showMore;
    $[11] = validItems;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const displayedItems = t4;
  const hasMore = validItems.length > DEFAULT_LIMIT;
  let t5;
  if ($[13] !== items || $[14] !== refine || $[15] !== updateTypeFilter || $[16] !== updateUrlParamImmediate) {
    t5 = item_2 => {
      if (!item_2.isRefined) {
        items.filter(_temp3).forEach(i_0 => refine(i_0.value));
      }
      refine(item_2.value);
      updateTypeFilter(item_2.isRefined ? null : item_2.value);
      updateUrlParamImmediate({
        pages: undefined
      });
    };
    $[13] = items;
    $[14] = refine;
    $[15] = updateTypeFilter;
    $[16] = updateUrlParamImmediate;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const handleRefine = t5;
  let t6;
  if ($[18] !== displayedItems || $[19] !== handleRefine) {
    let t7;
    if ($[21] !== handleRefine) {
      t7 = item_3 => <li key={item_3.value} className="cursor-pointer mt-4"><Checkbox id={`product-type-${item_3.value}`} checked={item_3.isRefined} onClick={() => handleRefine(item_3)} size="sm" className="group flex relative cursor-pointer"><span className="[&_a]:text-brand [&_a]:z-[2] [&_a]:focus:underline group-hover:text-brand text-gray pl-1 text-sm mt-px">{item_3.label}</span></Checkbox></li>;
      $[21] = handleRefine;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    t6 = displayedItems.map(t7);
    $[18] = displayedItems;
    $[19] = handleRefine;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[23] !== t6) {
    t7 = <ul className="list-none p-0 m-0">{t6}</ul>;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== hasMore || $[26] !== showMore) {
    t8 = hasMore && <button type="button" onClick={() => setShowMore(!showMore)} className="text-sm font-bold text-brand mt-3 bg-transparent border-0 cursor-pointer p-0 font-sans">{showMore ? "Show less" : "Show more"}</button>;
    $[25] = hasMore;
    $[26] = showMore;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t7 || $[29] !== t8) {
    t9 = <div className="[&_.group>span:first-of-type]:rounded">{t7}{t8}</div>;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
};
export default ProductTypeRefinementList;
function _temp(item) {
  return item.count > 0;
}
function _temp2(item_0) {
  return item_0.isRefined;
}
function _temp3(i) {
  return i.isRefined;
}